import { connect } from "react-redux";



// Actions
import { getClientDetails, getClientLocation, updateClient, updateClientLocation, addClientLocation, deleteClientLocation } from "../clientsActions";
// Component
import EditClient from "./EditClient";


// Store props to map with current state
const mapStateToProps = state => ({
  isLoading: state.client.isLoading,
  clientUpdateLoading: state.client.clientUpdateLoading,
  selectedOrganization: state.organization.selectedOrganization,
  clientDetails: state.client.clientDetails,
  clientLocationList: state.client.clientLocationList,
  addOrUpdateclientLocalMapLoading: state.client.addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo: state.client.createdClientLocationInfo,
  clientLocationDeleteLoading: state.client.clientLocationDeleteLoading,
  clientLocationCreateUpdateSuccess: state.client.clientLocationCreateUpdateSuccess,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getClientDetails: details => dispatch(getClientDetails({ ...details })),
  updateClient: details => dispatch(updateClient({ ...details })),
  getClientLocation: details => dispatch(getClientLocation({ ...details })),
  addClientLocation: details => dispatch(addClientLocation({ ...details })),
  deleteClientLocation: details =>
    dispatch(deleteClientLocation({ ...details })),
  updateClientLocation: details =>
    dispatch(updateClientLocation({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(EditClient);